import { SDialog } from "@avalara/skylab-sdk/react";
import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { unlinkBucketFromLocation } from "../../../../app/bucketsSlice/bucketActions";

function RemoveSelectedLocationsDialog(props) {
    const {
        isRemoveDialogOpen,
        setIsRemoveDialogOpen,
        selectedLocations,
        setSelectedLocations,
        assignedLocations,
        bucketId,
    } = props;
    const dispatch = useDispatch();
    const [isRemoving, setIsRemoving] = useState(false);

    const selectedCount = selectedLocations.size;
    const isSingleLocation = selectedCount === 1;
    const singleLocationName = isSingleLocation
        ? assignedLocations.find(loc => selectedLocations.has(loc.id))?.name
        : null;

    const handleRemoveConfirm = useCallback(() => {
        if (selectedLocations.size > 0) {
            setIsRemoving(true);
            const payload = {
                LocationIds: Array.from(selectedLocations),
            };
            dispatch(unlinkBucketFromLocation(payload, bucketId));
            setSelectedLocations(new Set());
            setIsRemoveDialogOpen(false);
            setIsRemoving(false);
        }
    }, [selectedLocations, dispatch, setSelectedLocations, setIsRemoveDialogOpen, bucketId]);

    const handleCancel = () => {
        setIsRemoveDialogOpen(false);
    };

    return (
        <SDialog
            open={isRemoveDialogOpen}
            onS-dismiss={handleCancel}
            id="remove-locations-dialog"
            aria-modal="true">
            <div slot="header">
                <span className="pad-end-xl margin-end-xl">
                    {isSingleLocation
                        ? `Remove ${singleLocationName} from the bucket?`
                        : `Remove ${selectedCount} locations from the bucket?`}
                </span>
            </div>

            <div slot="body">
                <span>
                    {isSingleLocation
                        ? "Certificates from this location can't be assigned to this bucket."
                        : "Certificates from selected locations can't be assigned to this bucket."}
                </span>
            </div>

            <div slot="footer">
                <button
                    className="primary small"
                    onClick={handleRemoveConfirm}
                    disabled={isRemoving}>
                    Remove
                </button>
                <button className="secondary small" onClick={handleCancel} disabled={isRemoving}>
                    Cancel
                </button>
            </div>
        </SDialog>
    );
}

export default RemoveSelectedLocationsDialog;
